import util from './util';

const { konsole } = util;

export default class TemplateParser {

  /* Tim
    * @original author: Premasagar Rose / github.com/premasagar/tim
    * @license: MIT license
  */
  constructor(delimiterStarts, delimiterEnds) {
    this.pattern = new RegExp((
      (delimiterStarts || "{{") +
        "\\s*([a-z0-9_$][\\.a-z0-9_]*)\\s*" +
      (delimiterEnds || "}}")
    ), "gi");
  }

  createRenderer(setup) {
    return (function(that, o) {
      return function(_template, _data) {
        if (_template) { o.template = _template; }
        if (_data) { o.data = _data || {}; }
        return that.parse(o.template, o.data, o.id, o.context);
      };
    })(this, setup);
  }

  parse(template, data, _id, _ctx, _except) {
    var that = this;
    var _errorPre = `tim [${_id || 'n/a'}]: `;
    _ctx = _ctx || data;
    if (typeof template === "function") { template = template.call(_ctx); }
    if (typeof template !== 'string') {
      konsole.log(_errorPre + 'invalid template]', template);
      return null;
    }

    return template.replace(that.pattern, function(tag, token) {
      var path = token.split("."), l = path.length, part = data, i = 0;

      for (; i < l; i++) {
        if (!part) { continue; }
        part = part[path[i]];

        if (typeof part === "undefined") {
          konsole.log(
            `${_errorPre}${tag} "${path[i]}" is not in the supplied data`, data
          );
        }
        else if (i === l - 1) {
          part = typeof part === 'function' ? part.call(_ctx) : part;
          if (that.pattern.test(part + '') && part !== _except) {
            // _except: to avoid possible out of range exceptions
            return that.parse(part, data, _id, _ctx, part);
          }
          else {
            return part;
          }
        }
      }
      return '';
    });
  }
};
